:host {
  --font-family: 'Montserrat';
  --body-size: var(--body-size-medium);
  height: auto;
}

.subsection-title {
  margin-bottom: calc(var(--spacer) * 2);
  font-family: 'Montserrat Medium', 'Montserrat', sans-serif;
  height: calc(var(--spacer) * 4);
}

#role-privileges-section {
  #role {
    margin-bottom: calc(var(--spacer) * 3);
    width: 360px;
  }

  #no-rights-selected-error {
    margin-left: calc(var(--spacer) * -1);

    &::part(container) {
      width: 870px;
      height: calc(var(--spacer) * 6);
      box-sizing: border-box;
      margin-top: calc(var(--spacer) * 4);
      text-align: left;
      line-height: 18px;
    }
  }

  #role-type-selection-drop-down {
    display: inline;
  }

  #rights-subtitle {
    font-size: var(--body-size-large);
    color: var(--main-titles-inputs-600);
    font-family: var(--font-family-secondary);
  }

  #role-rights {
    padding-top: calc(var(--spacer) * 3);
    .role-right {
      padding-bottom: calc(var(--spacer));

      .role-right-description {
        padding-top: var(--spacer);
      }
    }

    .role-right-checkbox {
      font-size: var(--body-size-medium);

      label {
        font-size: var(--body-size-medium);
      }
    }

    .subfield-right {
      padding-left: calc(var(--spacer) * 3);
    }
  }
}

#role-privileges-section[disable='true'] {
  #role-privileges-section-title,
  #dropdown-role-label,
  #role-rights .role-right .role-right-description {
    opacity: 0.5;
  }
}
